<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>DIGIMET Login</title>
</head>
<body>
    <div class="main-nav">
            <div class="row">
                <div class="col-7">
                    <img style="margin-bottom:20px;" height="35px" src="assets/img/logo/digimet-logo.png" alt="digimet-logo">
                    <a class="navbar-brand" href="#">
                        <span class="nav-brand-l konkhmer">DIGIMET</span>
                        <span class="nav-brand-m konkhmer">Connect</span>
                    </a>
                </div>
            </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="overlay" *ngIf="loading">
            <div class="snippet login-load">
                <div class="stage">
                    <div style="margin:10px 0 0 20px;padding-left: 10px;">
                        <div class="dot-pulse"></div>
                    </div>
                    <div style="margin: 70px 0 0 -45px;">{{japaneseLabels["loading_text"]}}</div>
                </div>
            </div>
            </div>
            <!-- form for sending new password -->
            <form class="login-form" (ngSubmit)="onSubmit($event)" >
                <div class="text-center mt-5">
                    <h4 class="konkhmer">パスワードを再設定してください</h4>
                </div>
                <div class="form-group mt-5">
                    <label style="font-size: 12px;">新しいパスワード</label>
                    <input style="border-radius: 0;color: #4F4F4F;" type="password" class="form-control" [(ngModel)]="password" name="password" (blur)="validation()" required>
                    <!-- Error Message -->
                    <div style="height: 10px;">
                        <span style="font-size: 14px;" *ngIf="!passwordError" >英数字を含む6文字以上で設定してください。</span>
                        <span *ngIf="passwordError" class="error">{{errorTexts["password_not_meet_requirements"]}}</span>
                    </div>
                </div>

                <div class="form-group mt-5">
                    <label style="font-size: 12px;">新しいパスワードの再入力</label>
                    <input style="border-radius: 0;color: #4F4F4F;" type="password" class="form-control" placeholder="" [(ngModel)]="confirmPassword" name="confirmPassword">
                </div>
                <!-- Error Message -->
                <div>
                  <span *ngIf="submitError" class="error"><span>{{errorTexts["password_does_not_match"]}}</span></span>
                </div>
                <div class="text-center mt-3">
                    <button type="submit" class="btn login-btn">設定完了する</button>
                </div>
            </form>
        </div>
    </div>
</body>
</html>
